export default Object.freeze({
  Nuevo: 1,
  Aprobado: 2,
  Denegado: 3,
  AprobadoModificado: 4,
  Sometido: 5,
  ProcesoCompletado: 6,
  SolicitudRechazada: 7,
  CompletadoPendienteAprobacion: 8,
  DevueltoAProveedor: 9,
});
